import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxsModule } from '@ngxs/store';

import { Environment } from '@fitscovery/common/environments';
import { APP_ENVIRONMENT } from './environment-injection';
import { BookingState } from './store';
import { ApiBookingService } from './services';
import { SnackbarService } from '@fitscovery/ui/snackbar';

@NgModule({
  imports: [
    CommonModule,
    NgxsModule.forFeature([ BookingState ])
  ],
  providers: [
    ApiBookingService,
    SnackbarService
  ]
})
export class BookingDataAccessModule {

  static forRoot(environment: Environment): ModuleWithProviders<BookingDataAccessModule> {
    return {
      ngModule: BookingDataAccessModule,
      providers: [{ provide: APP_ENVIRONMENT, useValue: environment }]
    };
  }

}
